module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAABHNCSVQICAgIfAhkiAAAAP9JREFUOI2tk01uwyAQhd9Lc4h01yOM7ewDR+oJ7Kv0JCb7Ilh22V1zikwX/pHlAKVqn2QJDTPDN88A/JO4D0jTaUWdi8HbYkZNo1TOoeL0Kh1rKfba1sTguRA5KG0M/sGznGLwhNICcMAymqoD7pffUm1rVgJpunFeGihtjO8uVSpyNqCOUB1ADssUq9kxeDuR6WeZ7n6BTuP8aIU0nYq0fYom92OOyU5KC2IUaefA4QpqD6iZDX5QEW2i4gsIgfI15xsAPJUa3W5f19PpWQB8xOjfSrlZIpG2Bznswtk3ln8ipIHqEIPn8q0H1BJtaFxiO3nPCqOdTW6vZPqf9Q0FLm0ou6zSTQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/TjianliJiangbei.png
// module id = dmmL
// module chunks = 1